var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatures = function SvgFeatures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 40.79,
    y1: 165.56,
    x2: 164.62,
    y2: 28.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 45.1,
    y1: 169.46,
    x2: 168.93,
    y2: 32.35,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100,0C44.86,0,0,44.86,0,100s44.86,100,100,100,100-44.86,100-100S155.14,0,100,0ZM100,185.71c-47.27,0-85.71-38.45-85.71-85.71S52.73,14.29,100,14.29s85.71,38.45,85.71,85.71-38.45,85.71-85.71,85.71Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.94,84.97c-.84-2.59-3.08-4.47-5.77-4.86l-35.77-5.2-15.99-32.41c-2.4-4.88-10.41-4.88-12.81,0l-15.99,32.41-35.77,5.2c-2.69.39-4.92,2.27-5.77,4.86-.84,2.58-.14,5.42,1.81,7.32l25.89,25.23-6.11,35.62c-.46,2.68.64,5.39,2.84,6.98,2.21,1.6,5.12,1.82,7.53.54l31.99-16.82,31.99,16.82c1.05.55,2.19.82,3.33.82,1.48,0,2.95-.46,4.2-1.37,2.2-1.6,3.3-4.3,2.84-6.98l-6.11-35.62,25.89-25.23c1.95-1.9,2.64-4.74,1.81-7.32ZM123.58,109.91c-1.68,1.64-2.45,4-2.05,6.32l4.3,25.06-22.5-11.83c-1.05-.55-2.18-.82-3.33-.82s-2.28.27-3.33.82l-22.5,11.83,4.3-25.06c.4-2.32-.37-4.68-2.05-6.32l-18.21-17.75,25.16-3.66c2.33-.33,4.34-1.8,5.38-3.91l11.25-22.8,11.25,22.8c1.04,2.11,3.05,3.57,5.38,3.91l25.16,3.66-18.21,17.75Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }));
};
export default SvgFeatures;